import Vue from "vue";
import {
  aisearchReportData,
  setHistroyList,
  setSearchHistory,
} from "@/services/modules/ai_search";
import router from '@/router/index'
// import { v4 as uuidv4 } from 'uuid'

export default {
  state: {
    searchGuide: false,
    searchEnterType: '', // 发起搜索类型 点击发送1；快捷键发送2；点击图片右侧引导词3；搜索热词点击4；点击历史记录搜索词5；右下角弹窗6；侧边栏弹泡7，划词8，图片搜索新人引导弹窗“开始搜索”点击 9
    changeSearchModelLocation: '', // 切换搜索模式来自于哪里
    searchResultImageUrl: '', //图搜，搜索结果中显示的图片
    largeImageShow: null, //展示大图
    draggingImageIntoDocument: false, //是否拖拽图片进入标签页
    aiSearchImageUploadId: '', // ai搜索图片搜索，上传图片成功后的imageId
    aiSearchImageUploadUrl: '', //ai搜索图片搜索，上传的图片url地址
    searchModel: '',
    aiSearchFetchDataCount: 0, // 请求异常次数
    startTime: 0,
    firstWordDuring: 0,
    showloginTips: false,
    abortCol: null, // 当前abort控制器实例
    isRouteBack: false,
    currentSearchParams: null, //当前搜索参数
    currentSearchCode: null,
    searchHistoryVisible: false,
    searchHistoryList: null,
    searchWordsHistory: [],
    result: {
      pictureAnalysis: '',
      reasoning: '', // 长思考
      linkList: [],
      answer: "",
      onebox: "",
      like: 0, // 1喜欢0无
      dislike: 0, //1不喜欢0无
    },
    advertise: [],
    advertiseNew: [],
    yybGames: [],
    website: null,
    relatedSearchWords: [],
    relatedSearchWordsLodaing: false,
    queryData: null,
    referenceData: null,
    haveSaveSessionId: false,
    sessionId: "",
    traceId: "",
    answerLoading: true,
    answerCompletion: false,
    generationStep: 0, // 0: 开始请求，分析问题；1：搜索全网；2：搜索全网，找到资料；3：整理答案，开始吐文字；4：完成，所有卡片接口渲染完成
    // markmindHtml: "",
    readyBlock: 0, //4：脑图。相关内容，延伸阅读，相关问题全部ready
    markMindDialogVisible: false,
    MarkMindStr: "", // 脑图
    relatedInfo: [], // 相关内容
    extendedReading: [], // 延伸阅读
    intoHistory: false,
    netWorkError: false,
    timeoutError: false,
    haveListenerLogin: false,
    pageFocusState: 0,
  },
  getters: {},
  mutations: {
    setSearchGuide(state, payload) {
      state.searchGuide = payload
    },
    setSearchEnterType(state, payload) {
      state.searchEnterType = payload
    },
    setChangeSearchModelLocation(state, payload) {
      state.changeSearchModelLocation = payload
    },
    setSearchResultImageUrl(state, payload) {
      state.searchResultImageUrl = payload
    },
    setLargeImageShow(state, payload) {
      state.largeImageShow = payload
    },
    setDraggingImageIntoDocument(state, payload) {
      state.draggingImageIntoDocument = payload
    },
    setAiSearchImageUploadUrl(state, data) {
      state.aiSearchImageUploadUrl = data
    },
    setAiSearchImageUploadId(state, data) {
      state.aiSearchImageUploadId = data
    },
    setSearchModel(state, data) {
      state.searchModel = data
    },
    setAiSearchFetchDataCount(state, payload) {
        state.aiSearchFetchDataCount = payload
    },
    setPageFocusState(state, data) {
      state.pageFocusState = data;
    },
    setSearchWordsHistory(state, data) {
      state.searchWordsHistory = data;
    },
    setSearchHistoryList(state, data) {
      state.searchHistoryList = data;
    },
    setGenerationStep(state, data) {
      state.generationStep = data;
    },
    setCurrentSearchParams(state, data) {
      state.currentSearchParams = data;
    },

    setAdvertiseNew(state, data) {
      state.advertiseNew = data;
    },
    setYybGames(state, data) {
      state.yybGames = data;
    },
    setAdvertise(state, data) {
      state.advertise = data;
    },
    setStartTime(state, data) {
      state.startTime = data;
    },
    setHaveListenerLogin(state, data) {
      state.haveListenerLogin = data;
    },
    serCurrentAnswer(state, data) {
      state.relatedSearchWordsLodaing = true
      // state.result = data;
      if (data.type === "error") {
        // aisearchReportData("show", "AISearch_Result_Error_page", "", [
        //   {
        //     key: "param2",
        //     value: JSON.stringify({
        //       engine: state.searchCode,
        //       type: 3,
        //     }),
        //   },
        // ]);
        state.abortCol && state.abortCol.abort();
        state.result.answer = data.message;
        state.netWorkError = true;
        state.answerLoading = false;
        state.relatedSearchWordsLodaing = false
        if (!window.pcmjssdk) {
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Error_page",
            "show",
            {
              params3: JSON.stringify({
                errtype: '搜索接口返回错误',
                word: state.currentSearchParams && state.currentSearchParams.query,
                engine: state.currentSearchParams && state.currentSearchParams.searchCode
              }),
            },
            true
          )
        }
      }
      if (data.type === "networkError") {
        // aisearchReportData("show", "AISearch_Result_Error_page", "", [
        //   {
        //     key: "param2",
        //     value: JSON.stringify({
        //       engine: state.searchCode,
        //       type: 3,
        //     }),
        //   },
        // ]);
        state.abortCol && state.abortCol.abort();
        state.result.answer = "网络异常，请稍后重试";
        state.netWorkError = true;
        state.answerLoading = false;
        state.relatedSearchWordsLodaing = false
        if (!window.pcmjssdk) {
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Error_page",
            "show",
            {
              params3: JSON.stringify({
                errtype: '网络异常',
                word: state.currentSearchParams && state.currentSearchParams.query,
                engine: state.currentSearchParams && state.currentSearchParams.searchCode
              }),
            },
            true
          )
        }
      }
      if (data.type === "timeoutError") {
        // aisearchReportData("show", "AISearch_Result_Error_page", "", [
        //   {
        //     key: "param2",
        //     value: JSON.stringify({
        //       engine: state.searchCode,
        //       type: 2,
        //     }),
        //   },
        // ]);
        state.abortCol && state.abortCol.abort();
        state.result.answer = "请求超时，请稍后再试";
        state.timeoutError = true;
        state.answerLoading = false;
        state.relatedSearchWordsLodaing = false
        if (!window.pcmjssdk) {
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Error_page",
            "show",
            {
              params3: JSON.stringify({
                errtype: '请求超时',
                word: state.currentSearchParams && state.currentSearchParams.query,
                engine: state.currentSearchParams && state.currentSearchParams.searchCode
              }),
            },
            true
          )
        }
      }
      if (!state.haveSaveSessionId) {
        // if (!data.sessionId) {
        //   // 解决百度图搜不返回 sessionId 问题
        //   data.sessionId = uuidv4()
        // }
        if (data.sessionId) {
          state.sessionId = data.sessionId;
          setHistroyList(
            {
              question: state.currentSearchParams.query,
            },
            null,
            data.sessionId,
            this.state?.loginInfo?.loginid
          );
          setSearchHistory(
            state.currentSearchParams.query,
            data.sessionId,
            this.state?.loginInfo?.loginid
          );
          state.haveSaveSessionId = true;
        }
      }
      if (data.traceId) state.traceId = data.traceId;
      if (data.type === "website") {
        state.website = data.website;
      }
      if (data.type === "onebox") {
        state.result.onebox = data.boxContent.pc;
      }
      if (data.type === "askfurther") {
        let result = data.word
        if (!result) {
          // 请求相关搜索词失败
          state.relatedSearchWordsLodaing = false
          return
        }
        const regex = /\d+[. ]([^\n]*)/g
        let matches
        const results = []
        while ((matches = regex.exec(result)) !== null) {
          results.push(matches[1])
        }
        console.log('相关搜索词', results)
        state.relatedSearchWords = results.splice(0, 3)
        state.relatedSearchWordsLodaing = false
        // 获取到相关搜索词，再存储一次数据
        setHistroyList(
          {
            question: state.currentSearchParams.query,
            id: state.sessionId,
          },
          {
            currentSearchParams: state.currentSearchParams,
            result: state.result,
            MarkMindStr: state.MarkMindStr,
            generationStep: state.generationStep,
            relatedInfo: state.relatedInfo,
            extendedReading: state.extendedReading,
            currentSearchCode: state.currentSearchCode,
            advertise: state.advertise,
            advertiseNew: state.advertiseNew,
            website: state.website,
            relatedSearchWords: state.relatedSearchWords,
            referenceData: state.referenceData,
            searchModel: state.searchModel,
            queryData: state.queryData,
            answerCompletion: state.answerCompletion,
            readyBlock: state.readyBlock,
          },
          state.sessionId,
          this.state.loginInfo.loginid
        );

        /**
        state.relatedSearchWords = data.word.map((item) => {
          let result = item;
          if (result.startsWith(`["`)) {
            result = result.slice(2);
          } else if (result.startsWith(`"`)) {
            result = result.slice(1);
          }
          if (result.endsWith(`"`)) {
            result = result.slice(0, -1);
          } else if (result.endsWith(`"]`)) {
            result = result.slice(0, -2);
          }
          return result;
        });
        */
      }
      if (data.type === 'query') {
        if (state.generationStep < 2) {
          state.generationStep = 2;
        }
        state.queryData = data.word
      } else if (data.type === "reference") {
        console.log('参考资料', data.reference)
        if (state.generationStep < 3) {
          state.generationStep = 3;
        }
        state.result.linkList = data.reference.list;
        state.referenceData = data.reference;
      } else if (data.type === "content") {
        // console.log("AISearch_Result_Start:", state.firstWordDuring);
        !state.firstWordDuring &&
            aisearchReportData('show', 'AISearch_Result_Start', '', [
                {
                    key: 'param2',
                    value: JSON.stringify({
                        engine: state.currentSearchCode,
                        time: Date.now() - state.startTime,
                        mode: (state.currentSearchParams && (!state.currentSearchParams.imageId && state.currentSearchParams.searchMode == 2)) ? 'Indepth' : 'Standard',
                    }),
                },
                {
                    key: 'param3',
                    value: JSON.stringify({
                        pageversion: Vue.prototype.searchVersion,
                    }),
                },
            ]);
        !state.firstWordDuring &&
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Start",
            "show",
            {
              param3: JSON.stringify({
                Is_Thinking: +state.currentSearchParams?.reasoningMode,
                from: router && router.default && router.default && router.default.currentRoute && router.default.currentRoute.query && router.default.currentRoute.query.from || 7,
                engine: state.currentSearchParams && state.currentSearchParams.searchCode,
                mode: (state.currentSearchParams && (!state.currentSearchParams.imageId && state.currentSearchParams.searchMode == 2)) ? 'Indepth' : 'Standard',
                time: Date.now() - state.startTime,
              }),
            },
            true
          );
        state.firstWordDuring = Date.now() - state.startTime;

        state.result.answer += data.text;
        state.generationStep = 4;
        if (state.answerLoading) state.answerLoading = false;
      } else if (data.type === 'picture') {
        state.generationStep = 1
        state.result.pictureAnalysis += data.text
      } else if (data.type === 'reasoning') {
        state.result.reasoning += data.text
      } else if (data.type === "mindmap") {
        state.MarkMindStr = data.mindMap.data;
      } else if (data.end === true) {
        if (data.type === "error") {
          return;
        }
        state.answerCompletion = true;
        if (state.readyBlock >= 2) {
          const SearchDuring = Date.now() - state.startTime;
          aisearchReportData('show', 'AISearch_Result_Finish', '', [
              {
                  key: 'param2',
                  value: JSON.stringify({
                      engine: state.currentSearchCode,
                      time: SearchDuring,
                      mode: (state.currentSearchParams && (!state.currentSearchParams.imageId && state.currentSearchParams.searchMode == 2)) ? 'Indepth' : 'Standard',
                  }),
              },
              {
                  key: 'param3',
                  value: JSON.stringify({
                      pageversion: Vue.prototype.searchVersion,
                  }),
              },
          ]);
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Finish",
            "show",
            {
              param3: JSON.stringify({
                Is_Thinking: +state.currentSearchParams?.reasoningMode,
                from: router && router.default && router.default && router.default.currentRoute && router.default.currentRoute.query && router.default.currentRoute.query.from || 7,
                engine: state.currentSearchParams && state.currentSearchParams.searchCode,
                mode: (state.currentSearchParams && (!state.currentSearchParams.imageId && state.currentSearchParams.searchMode == 2)) ? 'Indepth' : 'Standard',
                time: SearchDuring,
              }),
            },
            true
          );
          state.generationStep = 6;
          setHistroyList(
            {
              question: state.currentSearchParams.query,
              id: state.sessionId,
            },
            {
              currentSearchParams: state.currentSearchParams,
              result: state.result,
              MarkMindStr: state.MarkMindStr,
              generationStep: state.generationStep,
              relatedInfo: state.relatedInfo,
              extendedReading: state.extendedReading,
              currentSearchCode: state.currentSearchCode,
              advertise: state.advertise,
              advertiseNew: state.advertiseNew,
              website: state.website,
              relatedSearchWords: state.relatedSearchWords,
              referenceData: state.referenceData,
              searchModel: state.searchModel,
              queryData: state.queryData,
              answerCompletion: state.answerCompletion,
              readyBlock: state.readyBlock,
            },
            state.sessionId,
            this.state.loginInfo.loginid
          );
        } else {
          state.generationStep = 5;
        }
        state.generationStep = 6; // 兼容结果较少的搜索
      }
    },
    clearAnswer(state) {
      console.log("clearAnswer");
      state.firstWordDuring = null;
      state.currentSearchParams = null;
      state.abortCol && state.abortCol.abort();
      state.abortCol = null;
      state.result.pictureAnalysis = "";
      state.result.reasoning = "";
      state.result.answer = "";
      state.result.linkList = [];
      state.result.onebox = "";
      state.result.like = 0;
      state.result.dislike = 0;
      state.answerLoading = true;
      state.answerCompletion = false;
      state.generationStep = 0;
      state.MarkMindStr = "";
      state.relatedInfo = []; // 相关内容
      state.extendedReading = []; // 延伸阅读
      state.relatedSearchWords = [];
      state.referenceData = null;
      state.queryData = null;
      state.website = null;
      state.advertise = [];
      state.advertiseNew = [];
      state.setYybGames = [];
      state.haveSaveSessionId = false;
      state.sessionId = "";
      state.traceId = "";
      state.isRouteBack = false;
      state.readyBlock = 0;
      state.netWorkError = false;
      state.timeoutError = false;
    },
    setAnswerLoading(state, data) {
      state.answerLoading = data;
    },
    setCurrentSearchCode(state, data) {
      state.currentSearchCode = data;
    },
    setMarkMindDialogVisible(state, data) {
      state.markMindDialogVisible = data;
    },
    setMarkMindStr(state, data) {
      state.MarkMindStr = data;
    },
    setRelatedInfo(state, data) {
      state.relatedInfo = data;
    },
    setRelatedSearchWords(state, data) {
      state.relatedSearchWords = data;
    },
    setExtendedReading(state, data) {
      state.extendedReading = data;
    },
    setIntoHistroy(state, data) {
      state.intoHistory = data;
    },
    setReadyBlock(state) {
      state.readyBlock++;
      // 360和秘塔都是2个模块：脑图（360在正文），相关内容（秘塔无），延伸阅读，相关问题（在正文）
      if (state.readyBlock === 2 && !state?.abortCol?.signal?.aborted) {
        if (state.answerCompletion) {
          state.generationStep = 6;
          const SearchDuring = Date.now() - state.startTime;
          aisearchReportData('show', 'AISearch_Result_Finish', '', [
              {
                  key: 'param2',
                  value: JSON.stringify({
                      engine: state.currentSearchCode,
                      time: SearchDuring,
                      mode: (state.currentSearchParams && (!state.currentSearchParams.imageId && state.currentSearchParams.searchMode == 2)) ? 'Indepth' : 'Standard',
                  }),
              },
              {
                  key: 'param3',
                  value: JSON.stringify({
                      pageversion: Vue.prototype.searchVersion,
                  }),
              },
          ]);
          aisearchReportData(
            "SLB_AISearch_ResultPage",
            "AISearch_Result_Finish",
            "show",
            {
              param3: JSON.stringify({
                Is_Thinking: +state.currentSearchParams?.reasoningMode,
                from: router && router.default && router.default && router.default.currentRoute && router.default.currentRoute.query && router.default.currentRoute.query.from || 7,
                engine: state.currentSearchParams && state.currentSearchParams.searchCode,
                mode: (state.currentSearchParams && (!state.currentSearchParams.imageId && state.currentSearchParams.searchMode == 2)) ? 'Indepth' : 'Standard',
                time: SearchDuring,
              }),
            },
            true
          );
          setHistroyList(
            {
              question: state.currentSearchParams.query,
              id: state.sessionId,
            },
            {
              currentSearchParams: state.currentSearchParams,
              result: state.result,
              MarkMindStr: state.MarkMindStr,
              generationStep: state.generationStep,
              relatedInfo: state.relatedInfo,
              extendedReading: state.extendedReading,
              currentSearchCode: state.currentSearchCode,
              advertise: state.advertise,
              advertiseNew: state.advertiseNew,
              website: state.website,
              relatedSearchWords: state.relatedSearchWords,
              referenceData: state.referenceData,
              searchModel: state.searchModel,
              queryData: state.queryData,
              answerCompletion: state.answerCompletion,
              readyBlock: state.readyBlock,
            },
            state.sessionId,
            this.state.loginInfo.loginid
          );
        }
      }
    },

    setResultForHistory(state, data) {
      state.sessionId = data.sessionId;
      state.result = data.result;
      state.currentSearchParams = data.currentSearchParams;
      state.currentSearchCode = data.currentSearchCode;
      state.generationStep = data.generationStep;
      state.MarkMindStr = data.MarkMindStr;
      state.relatedInfo = data.relatedInfo;
      state.advertise = data.advertise;
      state.advertiseNew = data.advertiseNew;
      state.website = data.website;
      state.relatedSearchWords = data.relatedSearchWords;
      state.referenceData = data.referenceData;
      state.searchModel = data.searchModel;
      state.queryData = data.queryData;
      state.extendedReading = data.extendedReading;
      state.answerCompletion = data.answerCompletion;
      state.readyBlock = data.readyBlock;
      state.answerLoading = false;
    },
    setSearchHistoryVisible(state, data) {
      state.searchHistoryVisible = data;
    },
    setRouteBack(state, data) {
      state.isRouteBack = data;
    },
    setLikeAnswer(state, data) {
      state.result.like = data;
      // 当history=1时必有query，后续如果参数有变化该处逻辑需要调整
      if (
        // location.search.split("&").indexOf("history=1") > -1 &&
        state.generationStep === 6 ||
        state.generationStep === null
      ) {
        setHistroyList(
          {
            question: state.currentSearchParams.query,
            id: state.sessionId,
          },
          {
            currentSearchParams: state.currentSearchParams,
            result: state.result,
            MarkMindStr: state.MarkMindStr,
            generationStep: state.generationStep,
            relatedInfo: state.relatedInfo,
            extendedReading: state.extendedReading,
            currentSearchCode: state.currentSearchCode,
            advertise: state.advertise,
            advertiseNew: state.advertiseNew,
            website: state.website,
            relatedSearchWords: state.relatedSearchWords,
            referenceData: state.referenceData,
            searchModel: state.searchModel,
            queryData: state.queryData,
            answerCompletion: state.answerCompletion,
            readyBlock: state.readyBlock,
          },
          state.sessionId,
          this.state.loginInfo.loginid
        );
      }
    },
    setDisLikeAnswer(state, data) {
      state.result.dislike = data;

      if (
        // location.search.split("&").indexOf("history=1") > -1 &&
        state.generationStep === 6 ||
        state.generationStep === null
      ) {
        setHistroyList(
          {
            question: state.currentSearchParams.query,
            id: state.sessionId,
          },
          {
            currentSearchParams: state.currentSearchParams,
            result: state.result,
            MarkMindStr: state.MarkMindStr,
            generationStep: state.generationStep,
            relatedInfo: state.relatedInfo,
            extendedReading: state.extendedReading,
            currentSearchCode: state.currentSearchCode,
            advertise: state.advertise,
            advertiseNew: state.advertiseNew,
            website: state.website,
            relatedSearchWords: state.relatedSearchWords,
            referenceData: state.referenceData,
            searchModel: state.searchModel,
            queryData: state.queryData,
            answerCompletion: state.answerCompletion,
            readyBlock: state.readyBlock,
          },
          state.sessionId,
          this.state.loginInfo.loginid
        );
      }
    },
    setAbortCol(state, data) {
      state.abortCol = data;
    },
    setShowLoginTips(state, data) {
      state.showloginTips = data;
    },
  },
  actions: {},
};
